import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { semenProgramObject } from '../semenProgram/semenProgramObject'
import { inseminatorObject } from '../inseminator/inseminatorObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { semenBatchObject } from '../semenBatch/semenBatchObject'

export const inseminationObject = z.object({
  id: z.string().uuid(),
  programId: semenProgramObject.shape.id,
  programDosage: z.number().int(),
  earringNumber: z.number().int(),
  inseminatorId: inseminatorObject.shape.id,
  citizenId: citizenObject.shape.id,
  residenceId: residenceObject.shape.id.nullish(),
  isRepetition: z.boolean().nullish(),
  semenBatchId: semenBatchObject.shape.id.nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type InseminationType = z.infer<typeof inseminationObject>

export const propertyMap = {
  id: sql`id`,
  programId: sql`program_id`,
  programDosage: sql`program_dosage`,
  earringNumber: sql`earring_number`,
  inseminatorId: sql`inseminator_id`,
  citizenId: sql`citizen_id`,
  residenceId: sql`residence_id`,
  isRepetition: sql`is_repetition`,
  semenBatchId: sql`semen_batch_id`,
  sourceFilter: sql`source_filter`,
  clientId: sql`client_id`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
